import * as React from 'react';
import { Service } from './types';

export const ServiceContext = React.createContext<Service | null>(null);
ServiceContext.displayName = 'ServiceContext';
